import ComcastIframe from './ComcastIframe';
import { IframeXfinityPageRoutes, PATHS_TO_IFRAME_XFINITY } from './constants';

export default ComcastIframe;
export { IframeXfinityPageRoutes, PATHS_TO_IFRAME_XFINITY };
